import { api, getVisitorId } from "@/lib/api";

const knownLead = (items) => {
  for (const it of items) {
    if (it.hub_only) continue;
    const l = localStorage.getItem(`sv_lead_${it.slug}`);
    if (l) return { slug: it.slug, lead: l };
  }
  return null;
};

export const rememberHubEmail = (hubSlug) => {
  const e = new URLSearchParams(window.location.search).get("email");
  if (e && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e.trim())) localStorage.setItem(`sv_hub_email_${hubSlug}`, e.trim().toLowerCase());
};

// Returns a lead id for the target asset, or null when the visitor must fill in that page's form.
export async function hubAccess(hubSlug, items, it) {
  const own = localStorage.getItem(`sv_lead_${it.slug}`);
  const src = knownLead(items);
  const email = localStorage.getItem(`sv_hub_email_${hubSlug}`) || "";
  const body = { target: it.slug, visitor_id: getVisitorId(), email, slug: src?.slug || (own ? it.slug : ""), lead_id: src?.lead || own || "" };
  try {
    const { data } = await api.post(`/public/hubs/${hubSlug}/unlock`, body);
    if (data.lead_id !== own) {
      localStorage.setItem(`sv_lead_${it.slug}`, data.lead_id);
      const q = new URLSearchParams(window.location.search);
      api.post(`/public/campaigns/${it.slug}/visit`, { visitor_id: getVisitorId(), page: "landing", referrer: "hub",
        utm_source: q.get("utm_source") || "hub", utm_medium: q.get("utm_medium") || "", utm_campaign: q.get("utm_campaign") || "" }).catch(() => {});
    }
    return data.lead_id;
  } catch (e) {
    if (e.response?.status !== 403) throw e;
    if (own) localStorage.removeItem(`sv_lead_${it.slug}`);
    if (src && src.slug !== it.slug) localStorage.removeItem(`sv_lead_${src.slug}`);
    return null;
  }
}
